import * as React from 'react';
import AdminWrapper from './AdminWrapper';
import { connect } from 'react-redux';
import Constants from '../../core/libraries/Constants';
import RbLabel, { LabelSize } from '../../bosch-react/components/label/RbLabel';
import { IUserProfile } from '../Auth/types';
import { confirmDialog } from '../Dialog/actions';
import { RootState } from '../../store/store';
import { NavLink, withRouter } from 'react-router-dom';
import { Icon } from '@fluentui/react';

interface ManagementProps {
    userProfile: IUserProfile | undefined,
    confirmDialog: typeof confirmDialog,
    history: any,
}

class Management extends React.Component<ManagementProps, any> {

    componentDidMount() {
        setTimeout(() => {
            if (!this.props.userProfile?.permissions?.isAdmin) {
                /* Access Dialog */
                this.props.confirmDialog(
                    Constants.CONFIRMATION_MESSAGE.NO_PERMISSION.TITLE,
                    Constants.CONFIRMATION_MESSAGE.NO_PERMISSION.CONTENT,
                    true,
                    () => {
                        window.location.href = process.env.REACT_APP_HOME!;
                    }
                );
            }
        }, 5000)
    }

    render() {
        let categories: any[] = [
            { icon: "BarChart4", title: "Statistics", link: process.env.REACT_APP_STATISTICS!, permissions: [Constants.PERMISSIONS.ADMIN] },
            { icon: "Move", title: "Move", link: process.env.REACT_APP_MOVE!, permissions: [Constants.PERMISSIONS.ADMIN] },
            {
                icon: "Permissions", title: "Grant Access", link: process.env.REACT_APP_GRANT_ACCESS!, permissions: [Constants.PERMISSIONS.SUPER_ADMIN,
                Constants.PERMISSIONS.RND_DIVISION_ADMIN, Constants.PERMISSIONS.THESIS_ADMIN]
            },
            { icon: "FabricFolder", title: "Departments", link: process.env.REACT_APP_DEPARTMENTS!, permissions: [Constants.PERMISSIONS.SUPER_ADMIN] },
            { icon: "Ringer", title: "Notification Bar", link: process.env.REACT_APP_NOTIFICATION_BAR!, permissions: [Constants.PERMISSIONS.SUPER_ADMIN] },
            { icon: "Settings", title: "App Setting", link: process.env.REACT_APP_APP_SETTING!, permissions: [Constants.PERMISSIONS.CONFIGURATION] },
        ];
        
        let element: any = null;
        if (this.props.userProfile?.permissions?.checkHasPermission([Constants.PERMISSIONS.ADMIN])) {
            element = (
                <AdminWrapper history={this.props.history}>
                    <div className="ms-Grid">
                        {/* Title */}
                        <div className="ms-Grid-row">
                            <RbLabel className="header-title" style={{ textAlign: "center", marginLeft: "3rem" }} size={LabelSize.Large}>
                                Management Dashboard
                            </RbLabel>
                        </div>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid">
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm2" />
                                    <div className="ms-Grid-col ms-sm8">
                                        <div className="ms-Grid">
                                            <div className="ms-Grid-row">
                                                {categories.map((category: any) => {
                                                    return this.renderCategory(category);
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ms-Grid-col ms-sm2" />
                                </div>
                            </div>
                        </div>
                    </div>
                </AdminWrapper >
            );
        }
        return element;
    }

    renderCategory(category: { icon: string, title: string, link: string, permissions: any[] }) {
        if (this.props.userProfile?.permissions?.checkHasPermission(category.permissions)) {
            return (
                <div className="ms-Grid-col ms-sm4" key={category.icon}>
                    <NavLink key={category.title} to={category.link} className="ms-Grid"
                        style={{ cursor: "pointer", padding: "1rem" }}>
                        <div className="ms-Grid-row management-block">
                            <Icon iconName={category.icon} style={{ fontSize: '48px' }}></Icon>
                        </div>
                        <div className="ms-Grid-row management-label" style={{ textAlign: "center" }}>
                            <RbLabel className="management-title">{category.title}</RbLabel>
                        </div>
                    </NavLink>
                </div>
            );
        }
        else {
            return "";
        }
    }

}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile
});

export default withRouter(connect(mapStateToProps, { confirmDialog })(Management));